import { NavigationItem } from '@10d/tend-ui-header';
import { Submenu } from '../types';

export const filterMenu = (menuItems: Submenu<NavigationItem>[], filters: string[]) => {
  let result: Submenu<NavigationItem>[] = [];

  // Рекурсивно проходит по children каждого вложенного элемента подменю (children) и проверяет на пермишены
  // отображения (раздела/подраздела/подраздела подраздела и тд) для текущей роли
  const recurse = item => {
    let submenus = null;
    if ('children' in item) {
      submenus = (item?.children || []).reduce((accum, childrenElem) => {
        if (filters.includes(childrenElem.key as string)) {
          if ('children' in childrenElem) {
            childrenElem.children = recurse(childrenElem);
          }
          accum.push(childrenElem as Submenu<NavigationItem>);
        }
        return accum;
      }, []);
    }
    return submenus;
  };

  menuItems.forEach(item => {
    if ('key' in item) {
      if ('children' in item) {
        const submenus = recurse(item);

        if (submenus && (submenus as Submenu<NavigationItem>[]).length > 0) {
          result.push({ ...item, children: submenus as Submenu<NavigationItem>[] });
        }
      } else {
        const res = filters.some(val => (item as Submenu<NavigationItem>).key === val);
        if (res) {
          result.push(item);
        }
      }
    } else if ('children' in item) {
      result = result.concat(filterMenu(item.children as Submenu<NavigationItem>[], filters));
    }
  });

  return result;
};
